import { Box, Card, CircularProgress, Typography } from '@mui/material';
import { useGetOrganisation } from 'features/organisations/hooks/useGetOrganisation';
import { useTranslation } from 'react-i18next';
import { Blueprint } from 'types';

interface ProjectPartnersBoxProps {
  blueprintDetails: Blueprint;
}

export const ProjectPartnersBox = ({ blueprintDetails }: ProjectPartnersBoxProps) => {
  const { t } = useTranslation();

  if (!blueprintDetails) {
    return null;
  }

  const organisationId = blueprintDetails.organisationId;
  const shouldShowPartnerLogo = organisationId !== undefined && organisationId !== -1;

  const { organisation, isLoading: isOrganisationLoading } = useGetOrganisation(
    shouldShowPartnerLogo ? organisationId.toString() : ''
  );

  return (
    <Card sx={{ padding: 4, borderRadius: '8px' }}>
      <Typography variant="h6">{t('blueprints:details.projectPartners.title')}</Typography>

      <Box
        sx={{
          display: 'flex',
          gap: 3,
          flexWrap: 'wrap',
          mt: 3
        }}
      >
        <Box
          sx={{
            width: '149px',
            height: '60px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src="/static/greener-logo-large.png"
            alt="Greener Power Solutions Logo"
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
            }}
          />
        </Box>

        {shouldShowPartnerLogo && (
          <Box
            sx={{
              width: '149px',
              height: '60px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: (theme) => (organisation?.logoUrl ? 'transparent' : theme.palette.grey[200]),
            }}
          >
            {isOrganisationLoading ? (
              <CircularProgress size={24} />
            ) : organisation?.logoUrl ? (
              <img
                src={organisation.logoUrl}
                alt={organisation.name || 'Partner Logo'}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <Typography
                variant="h6"
                sx={{
                  fontSize: '24px',
                  fontWeight: 600,
                  color: 'grey.600',
                  textTransform: 'uppercase',
                }}
              >
                {organisation?.name?.charAt(0) || '-'}
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Card>
  );
};
